/**
 * SeedGrow WhatsApp + Google Analytics Integration (v3 - Simplificado)
 * Masters85 - Tracking WhatsApp clicks only
 * GA4 Measurement ID: G-N6MFGC54W4
 * 
 * Este script rastrea SOLO cuando el usuario hace clic
 * en el botón que abre WhatsApp (api.whatsapp.com)
 */

(function() {
  'use strict';

  console.log('[SeedGrow Analytics] Script inicializando...');

  // Esperar a que el DOM esté completamente cargado
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }

  function initTracking() {
    console.log('[SeedGrow Analytics] Inicializando rastreo de WhatsApp...');
    
    // Rastrear clics en enlaces de WhatsApp
    trackWhatsAppLinks();
    
    // Rastrear clics en botones que abren WhatsApp
    trackWhatsAppButtons();
  }

  /**
   * Rastrear clics en enlaces directos de WhatsApp
   */
  function trackWhatsAppLinks() {
    let attempts = 0;
    const maxAttempts = 30; // 15 segundos

    const checkInterval = setInterval(function() {
      attempts++;

      // Buscar todos los enlaces (a)
      const links = document.querySelectorAll('a[href*="api.whatsapp.com"], a[href*="wa.me"]');

      if (links.length > 0) {
        console.log('[SeedGrow Analytics] ✅ Enlaces de WhatsApp encontrados:', links.length);
        
        links.forEach(link => {
          if (!link.dataset.gaWhatsappTracked) {
            link.addEventListener('click', function(e) {
              trackEvent('whatsapp_link_clicked', {
                'event_category': 'engagement',
                'event_label': 'whatsapp_api_link',
                'page_path': window.location.pathname,
                'page_title': document.title,
                'whatsapp_url': this.href,
                'timestamp': new Date().toISOString()
              });
              
              console.log('[SeedGrow Analytics] ✅ Clic en enlace de WhatsApp registrado');
              console.log('[SeedGrow Analytics] URL:', this.href);
            });
            
            link.dataset.gaWhatsappTracked = 'true';
          }
        });

        clearInterval(checkInterval);
      }

      // Detener después de max intentos
      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.log('[SeedGrow Analytics] ⚠️ Enlaces de WhatsApp no encontrados después de intentos');
      }
    }, 500);
  }

  /**
   * Rastrear clics en botones de WhatsApp (SeedGrow widget)
   */
  function trackWhatsAppButtons() {
    let attempts = 0;
    const maxAttempts = 30;

    const checkInterval = setInterval(function() {
      attempts++;

      // Selectores para el botón flotante de SeedGrow
      const selectors = [
        '[class*="seedgrow"]',
        '[class*="whatsapp"]',
        '[id*="seedgrow"]',
        '.seed-grow-widget',
        '.whatsapp-widget',
        'iframe[title*="seedgrow"]',
        'iframe[title*="WhatsApp"]'
      ];

      let found = false;

      for (let selector of selectors) {
        try {
          const elements = document.querySelectorAll(selector);
          
          elements.forEach(el => {
            if (!el.dataset.gaButtonTracked) {
              el.addEventListener('click', function(e) {
                trackEvent('whatsapp_button_clicked', {
                  'event_category': 'engagement',
                  'event_label': 'seedgrow_button',
                  'page_path': window.location.pathname,
                  'page_title': document.title,
                  'timestamp': new Date().toISOString()
                });
                
                console.log('[SeedGrow Analytics] ✅ Clic en botón de WhatsApp');
              });
              
              el.dataset.gaButtonTracked = 'true';
              found = true;
            }
          });
        } catch (e) {
          // Ignorar errores
        }
      }

      if (found || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        if (found) {
          console.log('[SeedGrow Analytics] ✅ Botón de WhatsApp rastreado');
        }
      }
    }, 500);
  }

  /**
   * Función para enviar eventos a Google Analytics
   */
  function trackEvent(eventName, eventData = {}) {
    if (typeof gtag === 'undefined') {
      console.warn('[SeedGrow Analytics] ⚠️ Google Analytics no disponible');
      return false;
    }

    try {
      gtag('event', eventName, eventData);
      console.log('[SeedGrow Analytics] 📊 Evento enviado:', eventName);
      return true;
    } catch (error) {
      console.error('[SeedGrow Analytics] ❌ Error:', error);
      return false;
    }
  }
})();

// Log final
console.log('[SeedGrow Analytics] ✅ Script cargado - Masters85');
console.log('[SeedGrow Analytics] 📊 GA4 ID: G-N6MFGC54W4');
console.log('[SeedGrow Analytics] 🎯 Rastreando: Clic en botón WhatsApp');